import { axiosInstance } from "./apiConfig"

export const apiGetStoreAvailability = async (id, date, covers) => {
    const response = await axiosInstance.get(`/store/${id}/availability?date=${date}&covers=${covers}`);
    return response.data;
}


// WEBPACK FOOTER //
// ./src/api/getStoreAvailability.js